/* NRC refonte 2026 – interactions légères (sans dépendance) */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function openCart() {
    if (typeof window.nrcOpenCart === 'function') return window.nrcOpenCart();
    if (typeof window.openMoonBundleCartDrawer === 'function') return window.openMoonBundleCartDrawer();
    window.location.href = root + 'cart';
  }
  window.nrcAddToCart = function (items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Erreur');
        document.dispatchEvent(new CustomEvent('cartUpdated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('nrc:cart:added', { detail: data }));
        return data;
      });
    });
  };

  function closeAllQuick(except) {
    document.querySelectorAll('[data-nrc-card].is-quick').forEach(function (c) {
      if (c !== except) {
        c.classList.remove('is-quick');
        var t = c.querySelector('.nrc-card__plus[data-nrc-quick-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nrc-quick-toggle]');
    if (toggle) {
      e.preventDefault();
      var card = toggle.closest('[data-nrc-card]');
      var open = !card.classList.contains('is-quick');
      closeAllQuick(card);
      card.classList.toggle('is-quick', open);
      var plus = card.querySelector('.nrc-card__plus[data-nrc-quick-toggle]');
      if (plus) plus.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var add = e.target.closest('[data-nrc-add]');
    if (add) {
      e.preventDefault();
      if (add.classList.contains('is-loading')) return;
      add.classList.add('is-loading');
      var card2 = add.closest('[data-nrc-card]');
      window.nrcAddToCart([{ id: Number(add.getAttribute('data-nrc-add')), quantity: 1 }])
        .then(function () {
          add.classList.remove('is-loading');
          if (card2) card2.classList.remove('is-quick');
          openCart();
        })
        .catch(function (err) {
          add.classList.remove('is-loading');
          var msg = card2 && card2.querySelector('.nrc-card__error');
          if (!msg && card2) {
            msg = document.createElement('p');
            msg.className = 'nrc-card__error';
            msg.setAttribute('role', 'alert');
            card2.querySelector('.nrc-card__info').appendChild(msg);
          }
          if (msg) msg.textContent = err.message || (window.nrcStrings && nrcStrings.addError) || 'Error';
        });
      return;
    }

    if (!e.target.closest('[data-nrc-card]')) closeAllQuick(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllQuick(null);
  });

  /* 2e photo des cartes : chargée seulement quand le visiteur interagit
     (survol, toucher, ou après son 1er scroll pour les cartes visibles) → page plus légère au chargement */
  function loadAlt(m) {
    var img = m && m.querySelector('img[data-nrc-srcset], img[data-nrc-src]');
    if (!img) return;
    if (img.dataset.nrcSrcset) img.srcset = img.dataset.nrcSrcset;
    if (img.dataset.nrcSrc) img.src = img.dataset.nrcSrc;
    img.removeAttribute('data-nrc-srcset');
    img.removeAttribute('data-nrc-src');
  }
  document.addEventListener('mouseover', function (e) {
    if (e.target.closest) loadAlt(e.target.closest('.nrc-card__media'));
  }, { passive: true });
  var altWarm = false;
  function warmAlts() {
    if (altWarm) return;
    altWarm = true;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { loadAlt(en.target); io.unobserve(en.target); }
      });
    }, { rootMargin: '300px 0px' });
    var watch = function () {
      document.querySelectorAll('.nrc-card__media').forEach(function (m) {
        if (m.querySelector('img[data-nrc-srcset]')) io.observe(m);
      });
    };
    watch();
    document.addEventListener('nrc:grid-updated', watch);
  }
  ['scroll', 'pointerdown', 'keydown'].forEach(function (ev) {
    window.addEventListener(ev, warmAlts, { once: true, passive: true });
  });

  /* Cartes regroupées : clic / survol d'une pastille = photo, titre, prix et lien du coloris */
  function swCard(b) {
    var card = b.closest('[data-nrc-card]');
    if (!card || b.classList.contains('is-active')) return;
    card.querySelectorAll('.nrc-card__swb').forEach(function (x) { x.classList.toggle('is-active', x === b); });
    var url = b.getAttribute('data-url');
    card.querySelectorAll('a[href]').forEach(function (a) {
      if (a.classList.contains('nrc-card__notify')) { a.href = url + '#bis'; return; }
      if (a.closest('.nrc-card__media, .nrc-card__info') || a.classList.contains('nrc-card__plus')) a.href = url;
    });
    var t = card.querySelector('.nrc-card__title'); if (t) t.textContent = b.getAttribute('data-title');
    var pr = card.querySelector('.nrc-card__price'); if (pr) pr.textContent = b.getAttribute('data-price');
    var main = card.querySelector('.nrc-card__img:not(.nrc-card__img--hover)');
    if (main && b.dataset.srcset) {
      main.removeAttribute('data-nrc-lazy-srcset'); main.removeAttribute('data-nrc-lazy-src');
      main.srcset = b.dataset.srcset; main.src = b.dataset.src;
      main.classList.remove('is-swapping'); void main.offsetWidth; main.classList.add('is-swapping');
    }
    var alt = card.querySelector('.nrc-card__img--hover');
    if (alt) {
      if (b.dataset.srcset2) {
        alt.removeAttribute('data-nrc-srcset'); alt.removeAttribute('data-nrc-src');
        alt.srcset = b.dataset.srcset2; alt.src = b.dataset.src2; alt.style.display = '';
      } else { alt.style.display = 'none'; }
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.nrc-card__swb');
    if (!b) return;
    e.preventDefault(); swCard(b);
  });
  if (window.matchMedia && matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var b = e.target.closest && e.target.closest('.nrc-card__swb');
      if (b) swCard(b);
    }, { passive: true });
  }
  /* Une seule carte par famille, même quand la collection est chargée en plusieurs pages */
  function dedupeFamilies() {
    var seen = {};
    document.querySelectorAll('[data-nrc-family]').forEach(function (it) {
      var k = it.getAttribute('data-nrc-family');
      if (seen[k]) it.remove(); else seen[k] = 1;
    });
    /* Épuisés toujours en fin de grille, même après « Voir plus » */
    document.querySelectorAll('[data-nrc-grid]').forEach(function (g) {
      var off = [];
      Array.prototype.forEach.call(g.children, function (it) { if (it.querySelector('.nrc-card.is-unavailable')) off.push(it); });
      off.forEach(function (it) { g.appendChild(it); });
    });
  }
  dedupeFamilies();
  document.addEventListener('nrc:grid-updated', dedupeFamilies);

  /* Menu « Aide » : ouverture au clic (tablettes), fermeture au clic dehors / Échap */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.nrc-help__btn');
    document.querySelectorAll('[data-nrc-help].is-open').forEach(function (h) {
      if (!btn || !h.contains(btn)) { h.classList.remove('is-open'); h.querySelector('.nrc-help__btn').setAttribute('aria-expanded', 'false'); }
    });
    if (btn) {
      var h = btn.closest('[data-nrc-help]'), open = !h.classList.contains('is-open');
      /* « Nos produits » est un lien : clic direct avec une souris ; sur écran tactile, 1er appui = ouvre la liste, 2e = ouvre la page */
      /* « Nos produits » (lien) : ouvre toujours la page ; la liste s'ouvre au survol ou via la flèche */
      if (btn.tagName === 'A') return;
      h.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) btn.blur();
    }
  });
  /* Menu mobile : « Nos produits » dans le titre dépliable → ouvre la page (le + à droite déplie la liste) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.nrc-mshop__link');
    if (!a) return;
    e.preventDefault();
    window.location.href = a.href;
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-nrc-help]').forEach(function (h) { h.classList.remove('is-open'); var b = h.querySelector('.nrc-help__btn'); b.setAttribute('aria-expanded', 'false'); if (h.contains(document.activeElement)) b.blur(); });
  });

  /* Mobile : glisser sur la photo d'une carte affiche la 2e photo */
  var startX = null;
  document.addEventListener('touchstart', function (e) {
    loadAlt(e.target.closest('.nrc-card__media'));
    var m = e.target.closest('.nrc-card__media');
    startX = m && !m.closest('[data-nrc-scroller]') ? e.touches[0].clientX : null;
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (startX === null) return;
    var m = e.target.closest('.nrc-card__media');
    if (!m) return;
    var diff = startX - e.touches[0].clientX;
    if (Math.abs(diff) > 40) {
      m.classList.toggle('show-alt', diff > 0);
      startX = null;
    }
  }, { passive: true });

  /* ---------- Collection : tri, filtres, « Voir plus » ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-nrc-sort]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    if (window.nrcCollectionSwap) window.nrcCollectionSwap(url.toString(), true);
    else window.location.href = url.toString();
  });

  function setFilters(open, btn) {
    var drawer = document.querySelector('[data-nrc-filters]');
    if (!drawer) return;
    drawer.hidden = !open;
    document.documentElement.classList.toggle('nrc-lock', open);
    document.querySelectorAll('[data-nrc-filter-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) { var f = drawer.querySelector('summary, input, button'); if (f) f.focus(); }
    else if (btn) btn.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-nrc-filter-open]');
    if (o) { e.preventDefault(); setFilters(true); return; }
    var c = e.target.closest('[data-nrc-filter-close]');
    if (c) { e.preventDefault(); setFilters(false, document.querySelector('[data-nrc-filter-open]')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var d = document.querySelector('[data-nrc-filters]'); if (d && !d.hidden) setFilters(false, document.querySelector('[data-nrc-filter-open]')); }
  });

  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-nrc-more]');
    if (!more) return;
    var root2 = more.closest('[data-nrc-collection]');
    var grid = root2 && root2.querySelector('[data-nrc-grid]');
    if (!grid) return;
    e.preventDefault();
    if (more.classList.contains('is-loading')) return;
    more.classList.add('is-loading');
    var url = new URL(more.href, window.location.origin);
    url.searchParams.set('section_id', root2.getAttribute('data-section-id'));
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-nrc-grid] > *').forEach(function (it) { grid.appendChild(document.importNode(it, true)); });
        document.dispatchEvent(new Event('nrc:grid-updated'));
        var nextBtn = doc.querySelector('[data-nrc-more]');
        var shown = grid.children.length;
        var total = Number(more.getAttribute('data-total')) || shown;
        var sEl = root2.querySelector('[data-nrc-shown]'); if (sEl) sEl.textContent = shown;
        var pEl = root2.querySelector('[data-nrc-progress]'); if (pEl) pEl.style.width = Math.min(100, Math.round(shown * 100 / total)) + '%';
        var prev = root2.querySelector('.nrc-cmore__prev'); if (prev) prev.remove();
        if (nextBtn) { more.href = nextBtn.getAttribute('href'); more.classList.remove('is-loading'); }
        else more.remove();
        var cat0 = root2.getAttribute('data-cat'); if (cat0) applyCat(root2, cat0.split(','), false);
        var pageUrl = new URL(more.href || window.location.href, window.location.origin);
        history.replaceState(null, '', url.pathname + url.search.replace(/([?&])section_id=[^&]*&?/, '$1').replace(/[?&]$/, ''));
      })
      .catch(function () { window.location.href = more.href; });
  });

  /* ---------- Collection : catégories, tri et filtres sans recharger la page ---------- */
  var NRC_REDUCE = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function cRoot() { return document.querySelector('[data-nrc-collection]'); }
  function revealItems(items) {
    if (NRC_REDUCE) return;
    items.forEach(function (it, i) {
      it.classList.remove('is-in'); void it.offsetWidth;
      it.style.setProperty('--i', Math.min(i, 12));
      it.classList.add('is-in');
    });
  }
  function setCount(root, n) {
    var el = root.querySelector('[data-nrc-count]');
    if (el) el.textContent = n + ' ' + (n > 1 ? el.getAttribute('data-other') : el.getAttribute('data-one'));
  }
  function setActiveTab(root, a) {
    root.querySelectorAll('[data-nrc-ctab]').forEach(function (t) {
      var on = t === a;
      t.classList.toggle('is-active', on);
      if (on) t.setAttribute('aria-current', 'page'); else t.removeAttribute('aria-current');
    });
  }
  /* charge les pages suivantes (si la collection dépasse une page) avant de filtrer */
  function loadAll(root) {
    var more = root.querySelector('[data-nrc-more]');
    var grid = root.querySelector('[data-nrc-grid]');
    if (!more || !grid) return Promise.resolve();
    var u = new URL(more.href, window.location.origin);
    u.searchParams.set('section_id', root.getAttribute('data-section-id'));
    return fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-nrc-grid] > *').forEach(function (it) { grid.appendChild(document.importNode(it, true)); });
        document.dispatchEvent(new Event('nrc:grid-updated'));
        var next = doc.querySelector('[data-nrc-more]');
        if (next) { more.href = next.getAttribute('href'); return loadAll(root); }
        var w = root.querySelector('[data-nrc-more-wrap]'); if (w) w.remove();
      })
      .catch(function () {});
  }
  function applyCat(root, list, animate) {
    var grid = root.querySelector('[data-nrc-grid]');
    if (!grid) return;
    if (list.length && root.querySelector('[data-nrc-more]')) {
      if (animate && !NRC_REDUCE) grid.classList.add('is-out');
      loadAll(root).then(function () { applyCat(root, list, animate); });
      return;
    }
    var run = function () {
      var shown = [];
      grid.querySelectorAll('.nrc-cgrid__item').forEach(function (it) {
        var ok = !list.length || list.indexOf(it.getAttribute('data-type')) > -1;
        it.hidden = !ok;
        if (ok) shown.push(it);
      });
      var cEl = root.querySelector('[data-nrc-count]');
      setCount(root, list.length || !cEl ? shown.length : Number(cEl.getAttribute('data-total')) || shown.length);
      var em = root.querySelector('[data-nrc-client-empty]');
      if (em) em.hidden = shown.length > 0;
      grid.classList.remove('is-out');
      if (animate) revealItems(shown);
    };
    root.setAttribute('data-cat', list.join(','));
    if (animate && !NRC_REDUCE) { grid.classList.add('is-out'); setTimeout(run, 220); } else run();
  }
  function catFromUrl(animate) {
    var root = cRoot(); if (!root) return;
    var nav = root.querySelector('[data-nrc-ctabs]');
    if (!nav) return;
    var cat = new URL(window.location.href).searchParams.get('categorie');
    if (nav.getAttribute('data-mode') !== 'client') {
      /* filtre Shopify actif : un lien ?categorie=… (ex. depuis l'accueil) bascule sur l'onglet correspondant */
      if (!cat) return;
      var m2 = null;
      root.querySelectorAll('[data-nrc-ctab][data-kind="type"]').forEach(function (t) { if (t.getAttribute('data-types').split(',')[0] === cat) m2 = t; });
      if (m2 && !m2.classList.contains('is-active')) { history.replaceState(null, '', m2.getAttribute('href')); swap(m2.href, false); }
      return;
    }
    var tabs = root.querySelectorAll('[data-nrc-ctab]');
    var match = null;
    tabs.forEach(function (t) {
      if (cat && t.getAttribute('data-kind') === 'type' && t.getAttribute('data-types').split(',')[0] === cat) match = t;
      if (!cat && !match && t.getAttribute('data-kind') === 'all') match = t;
    });
    if (match) setActiveTab(root, match);
    applyCat(root, cat && match ? match.getAttribute('data-types').split(',').filter(Boolean) : [], animate);
  }
  function swap(url, push) {
    var root = cRoot();
    if (!root) { window.location.href = url; return; }
    var u = new URL(url, window.location.origin);
    var samePath = u.pathname === window.location.pathname;
    var grid = root.querySelector('[data-nrc-grid]');
    if (grid && !NRC_REDUCE) grid.classList.add('is-out');
    var f = new URL(u.toString());
    if (samePath) f.searchParams.set('section_id', root.getAttribute('data-section-id'));
    fetch(f.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-nrc-collection]');
        if (!fresh) throw new Error('no section');
        if (samePath) {
          ['.nrc-ctool', '.nrc-cgrid-wrap', '[data-nrc-filters]'].forEach(function (sel) {
            var a = root.querySelector(sel), b = fresh.querySelector(sel);
            if (a && b) a.replaceWith(document.importNode(b, true));
            else if (a && !b) a.remove();
            else if (!a && b) root.appendChild(document.importNode(b, true));
          });
        } else {
          var n = document.importNode(fresh, true);
          root.replaceWith(n); root = n;
          if (doc.title) document.title = doc.title;
          window.scrollTo(0, 0);
        }
        if (push) history.pushState({ nrc: 1 }, '', u.pathname + u.search);
        catFromUrl(false);
        revealItems(Array.prototype.slice.call(root.querySelectorAll('.nrc-cgrid__item:not([hidden])')));
        document.dispatchEvent(new Event('nrc:grid-updated'));
      })
      .catch(function () { window.location.href = url; });
  }
  window.nrcCollectionSwap = swap;
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-nrc-ctab]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var root = a.closest('[data-nrc-collection]');
    if (!root) return;
    e.preventDefault();
    if (a.classList.contains('is-active')) return;
    var nav = a.closest('[data-nrc-ctabs]');
    var kind = a.getAttribute('data-kind');
    setActiveTab(root, a);
    if (kind !== 'collection' && nav && nav.getAttribute('data-mode') === 'client' && root.querySelector('[data-nrc-grid]')) {
      applyCat(root, kind === 'type' ? a.getAttribute('data-types').split(',').filter(Boolean) : [], true);
      history.pushState({ nrc: 1 }, '', a.getAttribute('href'));
    } else {
      swap(a.href, true);
    }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-nrc-filters] form');
    if (!form) return;
    e.preventDefault();
    var u = new URL(form.getAttribute('action'), window.location.origin);
    new FormData(form).forEach(function (v, k) { if (v !== '') u.searchParams.append(k, v); });
    var cat = new URL(window.location.href).searchParams.get('categorie');
    if (cat) u.searchParams.set('categorie', cat);
    setFilters(false);
    swap(u.toString(), true);
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-nrc-filters] .nrc-drawer__foot a, .nrc-cempty a');
    if (!a || !cRoot()) return;
    e.preventDefault();
    setFilters(false);
    swap(a.href, true);
  });
  window.addEventListener('popstate', function () { if (cRoot()) swap(window.location.href, false); });
  catFromUrl(false);

  /* ---------- Onglets produits (accueil) ---------- */
  function selectTab(tab) {
    var wrap = tab.closest('[data-nrc-tabs]');
    wrap.querySelectorAll('[data-nrc-tab]').forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nrc-tab]');
    if (t) selectTab(t);
  });
  document.addEventListener('keydown', function (e) {
    var t = e.target.closest && e.target.closest('[data-nrc-tab]');
    if (!t || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(t.parentNode.querySelectorAll('[data-nrc-tab]'));
    var i = tabs.indexOf(t) + (e.key === 'ArrowRight' ? 1 : -1);
    var n = tabs[(i + tabs.length) % tabs.length];
    n.focus(); selectTab(n);
  });

  /* ---------- Fiche produit : points du carrousel mobile ---------- */
  document.querySelectorAll('.nrc-pdp__media').forEach(function (m) {
    var gal = m.querySelector('.nrc-pdp__gallery');
    var dots = m.querySelectorAll('.nrc-pdp__dots span');
    if (!gal || !dots.length) return;
    gal.addEventListener('scroll', function () {
      var i = Math.round(gal.scrollLeft / gal.clientWidth);
      dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
    }, { passive: true });
  });

  /* ---------- Recommandations produit (chargées quand on s'en approche) ---------- */
  document.querySelectorAll('[data-nrc-reco]').forEach(function (el) {
    if (el.children.length) return;
    var load = function () {
      fetch(el.getAttribute('data-url'), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-nrc-reco]');
          if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
        }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '600px' });
      io.observe(el);
    } else load();
  });

  /* ---------- Garde-fou panier : MoonBundle est LE panier ----------
     L'ancien panier du thème (et son voile gris) s'ouvrait en même temps que le
     tiroir MoonBundle ; en fermant MoonBundle, le voile restait et bloquait les clics. */
  function hasMoon() {
    return typeof window.openMoonBundleCartDrawer === 'function' && document.getElementById('moonbundle-cart-drawer');
  }
  function closeThemeCart() {
    var panel = document.querySelector('[theme-cart]');
    var ov = document.querySelector('[theme-overlay]');
    if (panel) panel.classList.remove('is-visible');
    if (ov && (!ov.style.zIndex || ov.style.zIndex === '60')) ov.classList.remove('is-visible');
    document.body.classList.remove('no-scroll');
  }
  var guardTries = 0;
  (function guard() {
    if (!(window.SF && SF.useSharedState)) { if (guardTries++ < 100) setTimeout(guard, 100); return; }
    var cartOpen = SF.useSharedState('cartOpen', false, 'ram');
    var overlay = SF.useSharedState('overlayVisible', { state: false, zIndex: '50' }, 'ram');
    cartOpen.onChange(function (v) {
      if (v && hasMoon()) {
        setTimeout(function () {
          cartOpen.set(false);
          overlay.set({ state: false, zIndex: '50' });
          closeThemeCart();
          if (typeof window.openMoonBundleCartDrawer === 'function') window.openMoonBundleCartDrawer();
        }, 0);
      }
    });
  })();
  /* /cart redirige vers /#cart : on ouvre le tiroir MoonBundle dès qu'il est prêt */
  if (location.hash === '#cart') {
    var cartTries = 0;
    (function openFromHash() {
      if (hasMoon()) {
        window.openMoonBundleCartDrawer();
        try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
      } else if (cartTries++ < 50) setTimeout(openFromHash, 200);
    })();
  }
  /* Filet de sécurité : si un voile reste affiché sans rien d'ouvert, on le retire */
  document.addEventListener('click', function () {
    setTimeout(function () {
      var ov = document.querySelector('[theme-overlay].is-visible');
      if (!ov) return;
      var anyOpen = document.querySelector('[theme-cart].is-visible, .size-guide-popup.is-visible, .mobile-menu.is-active');
      if (!anyOpen) { ov.classList.remove('is-visible'); document.body.classList.remove('no-scroll'); }
    }, 400);
  }, true);
})();
